module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAAR0lEQVQ4T2PcuffwEQYGBmsGCsB/RoYjjDv3Hv5PgRlwrXCD3J1tGckxEOYQ6htEjmuQ9YyEMBp8sUY1F1Ej+inOawwMDEcBsEFIb0bhz3QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/cd.png
// module id = A6m1
// module chunks = 1